export const appName = 'Bottom Detector';
export const appAbbreviation = 'BD';
export const appVersion = '1.0.3';
export const appAuthor = 'Astra Bun';
export const appShortDescription = 'A simple app to detect bottoms.';
export const appUrl = "https://bottomdetector.astrabun.com";